import React from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";

import Header from "../components/header";
import ChangePassword from "../components/change_password";
import "./password_change.css";

const PasswordChange = (props) => {
  let { user_uid, entity_uid } = useParams();

  return (
    <div className='passwordchange-container'>
      <Helmet>
        <title>password change - bravhurDB</title>
        <meta
          name='description'
          content='the business ready database, featuring field level streaming, IoT support, GraphQL, fine grained access control, in-memory graph database backend'
        />
        <meta property='og:title' content='password change - bravhurDB' />
        <meta
          property='og:description'
          content='the business ready database, featuring field level streaming, IoT support, GraphQL, fine grained access control, in-memory graph database backend'
        />
      </Helmet>
      <Header rootClassName='header-root-class-name12'></Header>
      <div className='passwordchange-contentframe'>
        <div className='passwordchange-contentcontainer'>
          <div className='passwordchange-homepanel'>
            <div className='passwordchange-leftpanel'>
              <span className='passwordchange-leftpaneltext'>Change Password</span>
              <ChangePassword rootClassName='changepassword-root-class-name' user_uid={user_uid} entity_uid={entity_uid}></ChangePassword>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PasswordChange;
